<template>
  <div>
    <div
      v-for="cat in categories"
      :key="cat.id"
    >
      <h2>{{ cat.name }}</h2>
      <p v-html="cat.text" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AdditionalInfo',
  props: {
    results: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('tests', ['test']),
    categories() {
      if (!this.test) {
        return [];
      }
      const enabledCategories = this.test.categories.filter((cat) => (cat.min && cat.min.enabled) || (cat.max && cat.max.enabled));
      return enabledCategories
        .filter((cat) => {
          const result = this.results.find((res) => res.id === cat.id);
          if (!result) {
            return false;
          }
          if (cat.min.enabled && result.percent < cat.min.value) {
            return true;
          }
          return cat.max.enabled && result.percent > cat.max.value;
        })
        .map((cat) => {
          const result = this.results.find((res) => res.id === cat.id);
          if (cat.min.enabled && result.percent < cat.min.value) {
            return {
              ...cat,
              text: cat.min.text,
            };
          }
          return {
            ...cat,
            text: cat.max.text,
          };
        });
    },
  },
};
</script>

<style scoped>

</style>
